<lib-dialog
  [title]="
    (isConfirmEmailProcess
      ? user?.email
        ? 'contact-update-dialog.text.confirm-email'
        : 'contact-update-dialog.text.enter-email'
      : user?.phoneNr
      ? 'contact-update-dialog.text.confirm-phone-number'
      : 'contact-update-dialog.text.enter-phone-number'
    ) | translate
  "
  [displayActionContainerAsColumnOnMobile]="true"
  [isLoading]="isLoading"
  (closeButtonClick)="closeDialog()"
>
  <div body>
    <ng-container *ngIf="isConfirmEmailProcess">
      <div>
        {{
          (user?.email
            ? 'contact-update-dialog.text.confirm-email-hint'
            : 'contact-update-dialog.text.enter-email-hint'
          ) | translate
        }}
      </div>

      <lib-spacer></lib-spacer>

      <mat-form-field>
        <mat-label>{{ 'contact-data-form.text.email' | translate }}</mat-label>
        <input
          [formControl]="emailControl"
          matInput
          name="email"
          type="email"
          [autocomplete]="'off'"
        />
        <mat-error>
          <lib-error-message-wrapper
            [control]="emailControl"
          ></lib-error-message-wrapper>
        </mat-error>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="!isConfirmEmailProcess && isConfirmPhoneNrProcess">
      <div>
        {{
          (user?.phoneNr
            ? 'contact-update-dialog.text.confirm-phone-number-hint'
            : 'contact-update-dialog.text.enter-phone-number-hint'
          ) | translate
        }}
      </div>

      <lib-spacer></lib-spacer>

      <lib-phone-number-input
        [formControl]="phoneNrControl"
      ></lib-phone-number-input>
    </ng-container>
  </div>

  <ng-container action>
    <button mat-stroked-button (click)="closeDialog()">
      {{ 'contact-update-dialog.buttons.skip' | translate }}
    </button>

    <button
      mat-flat-button
      color="primary"
      [disabled]="!isAbleToSubmit()"
      (click)="submit()"
    >
      {{ 'contact-update-dialog.buttons.confirm' | translate }}
      <ng-container *ngIf="resendPinConfirmCountdownInSecond"
        >({{
          'contact-update-dialog.text.in-second'
            | translate : { seconds: resendPinConfirmCountdownInSecond }
        }})</ng-container
      >
    </button>
  </ng-container>
</lib-dialog>
